<template>
  <button
    class="tw-flex tw-items-center tw-w-full tw-text-left tw-outline-none tw-p-4 hover:tw-bg-light-3"
    :class="{'tw-bg-light-3 tw-text-blue' : isActive}"
  >
    <div>{{text}}</div>
    <i v-if="isActive" class="bx bxs-check-circle tw-text-green tw-text-3xl tw-ml-1"></i>
  </button>

</template>
<script>
  export default {
    props : {
      text : {},
      isActive : {},
    }
  }
</script>
